import { FormSchema } from '@condo/domain';

export enum DDTabValue {
    Overview = 'overview',
    DocumentChecklist = 'document-checklist',
    QuestionsAndAnswers = 'questions-and-answers',
    SourcingChecklist = 'sourcing-checklist',
    ObjectChecklist = 'object-checklist',
    VicinityChecklist = 'vicinity-checklist',
    RentChecklist = 'rent-checklist',
    TechnicalChecklist = 'technical-checklist',
    TechnicalOnsiteChecklist = 'technical-onsite-checklist',
    LegalChecklist = 'legal-checklist',
    CommercialChecklist = 'commercial-checklist',
    DealClosingChecklist = 'deal-closing-checklist',
    DueDiligenceV2 = 'due-diligence-v2',
}

export const FormSchemaToDDTabValue: Record<FormSchema, DDTabValue> = {
    [FormSchema.MfhDocumentChecklist]: DDTabValue.DocumentChecklist,
    [FormSchema.SourcingTasksDD]: DDTabValue.SourcingChecklist,
    [FormSchema.ObjectExaminationDD]: DDTabValue.ObjectChecklist,
    [FormSchema.VicinityExaminationDD]: DDTabValue.VicinityChecklist,
    [FormSchema.RentDD]: DDTabValue.RentChecklist,
    [FormSchema.TechnicalDD]: DDTabValue.TechnicalChecklist,
    [FormSchema.TechnicalOnSiteDD]: DDTabValue.TechnicalOnsiteChecklist,
    [FormSchema.LegalDD]: DDTabValue.LegalChecklist,
    [FormSchema.CommercialDD]: DDTabValue.CommercialChecklist,
    [FormSchema.DealClosingDD]: DDTabValue.DealClosingChecklist,
    [FormSchema.DDOverview]: DDTabValue.Overview,
    [FormSchema.MfhDDv2]: DDTabValue.DueDiligenceV2,
} as const;
